"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerTypeRate = exports.CannabisTypeRate = exports.CategoryRate = void 0;
const TaxRule_1 = require("./TaxRule");
class CategoryRate extends TaxRule_1.TaxRule {
    constructor(params) {
        var _a;
        super();
        this.categoryIds = [];
        this.categoryIds = (_a = params.categoryIds) !== null && _a !== void 0 ? _a : [];
        this.rateAmount = params.rateAmount;
    }
    matches(taxRateContext, itemContext) {
        const { categoryId, parentCategoryId } = itemContext;
        // empty `categoryIds` means the tax rate should be applied to all
        if (this.categoryIds.length === 0)
            return true;
        const categoryIdMatching = categoryId
            ? this.categoryIds.includes(categoryId)
            : false;
        if (categoryIdMatching)
            return true;
        if (parentCategoryId)
            return this.categoryIds.includes(parentCategoryId);
        return false;
    }
    getRateAmount() {
        return this.rateAmount;
    }
}
exports.CategoryRate = CategoryRate;
/**
 * Cannabis Type Rate
 * Equivalent to Java's CannabisTypeRate
 */
class CannabisTypeRate extends TaxRule_1.TaxRule {
    constructor(params) {
        super();
        this.cannabisType = params.cannabisType;
        this.rateAmount = params.rateAmount;
    }
    matches(taxRateContext, itemContext) {
        if (itemContext.cannabisType === null || this.cannabisType === null) {
            return false;
        }
        return itemContext.cannabisType === this.cannabisType;
    }
    getRateAmount() {
        return this.rateAmount;
    }
}
exports.CannabisTypeRate = CannabisTypeRate;
/**
 * Consumer Type Rate
 * Equivalent to Java's ConsumerTypeRate
 */
class ConsumerTypeRate extends TaxRule_1.TaxRule {
    constructor(params) {
        super();
        this.consumerType = params.consumerType;
        this.rateAmount = params.rateAmount;
    }
    matches(taxRateContext, itemContext) {
        const customerContext = taxRateContext.customerContext;
        if (customerContext === null || customerContext.consumerType === null || this.consumerType === null) {
            return false;
        }
        return customerContext.consumerType === this.consumerType;
    }
    getRateAmount() {
        return this.rateAmount;
    }
}
exports.ConsumerTypeRate = ConsumerTypeRate;
//# sourceMappingURL=TaxRates.js.map